module.exports = __webpack_public_path__ + "assets/f2bab2a5b4177bccc3e7920084822c4d.svg";